import { render, staticRenderFns } from "./RegionLeftSidebar.vue?vue&type=template&id=678c3986&"
import script from "./RegionLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./RegionLeftSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports